import {Dayjs} from 'dayjs';
import {IMediaTrack} from './MediaTrack.dto';
import {IUserBase} from './User.dto';
export interface IDemoStingerCreateProps {
  category: string;
  name: string;
  mascot: string;
  option: number;
  date: Dayjs | null;
  note: string;
  category_option: string;
  station_name: string;
  prospect: string;
  partner_id: number;
  product_rep_id: number;
  product_rep: string;
  advertiser?: string;
  advertiser_url?: string;
}

export interface IDemoStingerValues {
  id: number;
  request_id: number;
  request_type: number;
  category: number;
  name: string;
  mascot: string;
  option: number;
  date: string;
  note: string;
  category_option: string;
  task_slug?: string;
  user?: IUserBase;
  status: string;
  file_url: string;
  file_name: string;
  station_name: string;
  prospect_partner: string;
  media_track: IMediaTrack;
  advertiser?: string;
  advertiser_url?: string;
}
export interface IDemoStingerDefaultProps {
  id: number;
  product: string;
  script: string;
  type: string;
}
export interface IDemoStingerMessageProps {
  id: number;
  name: string;
  message: string;
  file_url?: string;
  file_name?: string;
}
export interface IDemoStingerResponseProp {
  values: IDemoStingerValues;
  default_stingers: IDemoStingerDefaultProps[];
  messages: IDemoStingerMessageProps[];
  adScript: IDemoStingerMessageProps[];
  partnerStinger: IDemoStingerMessageProps[];
}
export interface IDemoScriptStateProp {
  id: number;
  name: string;
  message?: string;
  file?: File | null;
  file_url?: string;
  file_name?: string;
}
export interface IDemoResponse {
  id: number;
  name: string;
  option: string;
  date: string;
  created_by: string;
  status: string;
  file_url: string;
  note?: string;
  advertiser?: string;
  advertiser_url?: string;
}
export const LabelName: {[key: string]: string} = {
  '1': 'School/District Name',
  '2': 'Target Sponsor Name',
  '3': 'Company/facility ',
  '4': 'School Name',
  '5': 'School/District Name',
};
export interface IDemoAdSpotProps {
  id: number;
  name: string;
  adspot: string;
  file: File[] | null;
}
export interface IDemoStringerProp {
  id: number;
  label: string;
  name: string;
  file: File | null;
}
